import { forwardRef } from 'react';
import { cn } from '@/shared/utils/cn';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  hasError?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { hasError, className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={hasError ? 'true' : undefined}
      className={cn(
        'block w-full rounded-adipa-md border bg-adipa-surface px-3 py-2',
        'text-sm text-adipa-text-primary placeholder:text-adipa-text-placeholder',
        'transition-colors duration-adipa-fast outline-none',
        'border-adipa-border',
        'focus:border-adipa-primary focus:ring-[3px] focus:ring-adipa-focus-ring',
        hasError && 'border-adipa-error focus:border-adipa-error focus:ring-adipa-error-ring',
        'disabled:cursor-not-allowed disabled:bg-adipa-surface-muted disabled:text-adipa-text-secondary disabled:opacity-70',
        'read-only:cursor-default read-only:bg-adipa-surface-muted',
        className,
      )}
      {...props}
    />
  );
});
